import { useTranslation } from 'react-i18next';
import type { ApplicationIndustry } from '@/api/types.ts';

export const useIndustryNameGetter = () => {
  const { i18n } = useTranslation();
  const { language } = i18n;

  return (industry: ApplicationIndustry) => {
    if (language === 'es' && industry.display_name_spanish) {
      return industry.display_name_spanish;
    }

    return industry.display_name;
  };
};
